import "../styles/app/app.scss";

import config from "config";
import { Fragment, useContext, useEffect, useState } from "react";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { RouterProvider } from "react-router-dom";
import { iconHandler } from "../app/common/fontAwesomeIcons";
import routes from "./routes";

import {
  connection,
  notificationStatus,
  onCancelNotificationReceived,
  onHoldNotificationReceived,
  onCancelNotificationSeen,
  onCancelNotificationStatus,
  startConnection,
  stopConnection,
} from "app/services/notificationService";
import { AppContext } from "./appContext";

const { companyName } = config;

function App() {
  const { getNotificationByBackend, getNotificationSeen, user } =
    useContext(AppContext);
  const [userId, setUserId] = useState("");
  useEffect(() => {
    document.getElementById("fabIcon").href = `/assets/images/Logo/Chandni.gif`;
    // document.getElementById("documentTitle").innerHTML = `${companyName}`;
    document.getElementById("documentTitle").innerHTML = `Chandni Online`;
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") {
      const originalLog = console.log;
      const originalInfo = console.info;

      console.log = () => {};
      console.info = () => {};

      return () => {
        console.log = originalLog;
        console.info = originalInfo;
      };
    }
  }, []);

  useEffect(() => {
    setUserId(user?.userId);
  }, [user?.userId]);

  // useEffect(() => {
  //   (async () => {
  //     if (userId !== null && userId !== undefined && userId !== "") {
  //       await notificationStatus(userId);
  //     }
  //   })();
  // }, [userId]);
  useEffect(() => {
    const run = async () => {
      if (
        userId !== null &&
        userId !== undefined &&
        userId !== "" &&
        (user?.role === "Admin" || user?.role === "Ticketing")
      ) {
        await notificationStatus(userId);
      }
    };

    run();
  }, [userId, user?.role]);

  useEffect(() => {
    if (typeof window !== "undefined" && "Notification" in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          // console.log("Notification permission granted.");
        } else {
          // console.warn("Notification permission denied.");
        }
      });
    }

    if (
      userId !== "" &&
      (user?.role === "Admin" || user?.role === "Ticketing")
    ) {
      startConnection().then(() => {
        onCancelNotificationReceived((notification) => {
          console.log("Cancel Notification Received: ", notification);
          if (notification?.data !== null || notification?.message !== null) {
            debugger;
            getNotificationByBackend(notification);
            if (!notification.isSeen) {
              NotificationManager.success(notification?.message);

              if (Notification.permission === "granted") {
                new Notification("New Notification", {
                  body: notification.message,
                });
              }
            }
          }
        });

        onHoldNotificationReceived((notification) => {
          console.log("hold Notification Received: ", notification);
          if (notification?.data !== null || notification?.message !== null) {
            getNotificationByBackend(notification);
            if (!notification.isSeen) {
              NotificationManager.success(notification?.message);

              if (Notification.permission === "granted") {
                new Notification("New Notification", {
                  body: notification.message,
                });
              }
            }
          }
        });

        onCancelNotificationSeen((notification) => {
          console.log("Notification Seen Received: ", notification);
          if (notification !== null) {
            getNotificationByBackend(notification);
            // if (Notification.permission === "granted") {
            //   new Notification("New Notification", {
            //     body: notification.message,
            //   });
            // }
          }
        });

        onCancelNotificationStatus((notification) => {
          console.log("Notification Status Received: ", notification);
          if (notification !== null) {
            getNotificationByBackend(notification);
            // if (Notification.permission === "granted") {
            //   new Notification("New Notification", {
            //     body: notification.message,
            //   });
            // }
          }
        });
      });
    }

    return () => {
      if (connection) {
        connection.off("cancel_notification");
        connection.off("hold_notification");
        connection.off("notification-seen");
        // stopConnection();
      }
    };
  }, [userId]);

  iconHandler();
  return (
    <Fragment>
      <RouterProvider router={routes} />
      <NotificationContainer />
    </Fragment>
  );
}

export default App;
